import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Email from 'services/data/email';

export default function EmailMeta({ email }) {
  return (
    <div className="email-meta">
      <div className="email-meta-from">
        <h5>From</h5>
        <div className="email-meta-address">{Email.getFromLong(email)}</div>
      </div>
      <div className="email-meta-to">
        <h5>To</h5>
        { _.map(email.parsedTo, address =>
          <div className="email-meta-address" key={address.address}>{Email.getLongAddress(address)}</div>
        )}
      </div>
      { !!(email.parsedCc && email.parsedCc.length) &&
        <div className="email-meta-cc">
          <h5>CC</h5>
          { _.map(email.parsedCc, address =>
            <div className="email-meta-address" key={address.address}>{Email.getLongAddress(address)}</div>
          )}
        </div>
      }
    </div>
  );
}

EmailMeta.propTypes = {
  email: PropTypes.object
};



// WEBPACK FOOTER //
// ./app/components/models/email/emailMeta.js